import React from 'react';
import { status } from '@atlaskit/adf-schema';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { IconStatus } from '@atlaskit/editor-common/quick-insert';
import { commitStatusPicker, createStatus, removeStatus, updateStatusWithAnalytics } from './actions';
import { keymapPlugin } from './pm-plugins/keymap';
import createStatusPlugin from './pm-plugins/plugin';
import { pluginKey } from './pm-plugins/plugin-key';
import { ContentComponent } from './ui/ContentComponent';
var baseStatusPlugin = function baseStatusPlugin(_ref) {
  var _api$analytics;
  var options = _ref.config,
    api = _ref.api;
  return {
    name: 'status',
    nodes: function nodes() {
      return [{
        name: 'status',
        node: status
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'status',
        plugin: function plugin(pmPluginFactoryParams) {
          return createStatusPlugin(pmPluginFactoryParams, options);
        }
      }, {
        name: 'statusKeymap',
        plugin: keymapPlugin
      }];
    },
    actions: {
      commitStatusPicker: commitStatusPicker,
      updateStatus: updateStatusWithAnalytics(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)
    },
    commands: {
      removeStatus: removeStatus
    },
    getSharedState: function getSharedState(state) {
      if (!state) {
        return undefined;
      }
      var pluginState = pluginKey.getState(state);
      return pluginState ? {
        isNew: pluginState.isNew,
        showStatusPickerAt: pluginState.showStatusPickerAt,
        focusStatusInput: pluginState.focusStatusInput
      } : undefined;
    },
    contentComponent: function contentComponent(_ref2) {
      var editorView = _ref2.editorView,
        popupsMountPoint = _ref2.popupsMountPoint,
        popupsBoundariesElement = _ref2.popupsBoundariesElement,
        popupsScrollableElement = _ref2.popupsScrollableElement;
      var domAtPos = editorView.domAtPos.bind(editorView);
      return /*#__PURE__*/React.createElement(ContentComponent, {
        domAtPos: domAtPos,
        api: api,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement
      });
    }
  };
};
var decorateWithPluginOptions = function decorateWithPluginOptions(plugin, options, api) {
  if ((options === null || options === void 0 ? void 0 : options.menuDisabled) === true) {
    return plugin;
  }
  plugin.pluginsOptions = {
    quickInsert: function quickInsert(_ref3) {
      var formatMessage = _ref3.formatMessage;
      return [{
        id: 'status',
        title: formatMessage(messages.status),
        description: formatMessage(messages.statusDescription),
        priority: 700,
        keywords: ['lozenge'],
        icon: function icon() {
          return /*#__PURE__*/React.createElement(IconStatus, null);
        },
        action: function action(insert, state) {
          var _api$analytics2;
          var tr = createStatus(state);
          api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent({
            action: ACTION.INSERTED,
            actionSubject: ACTION_SUBJECT.DOCUMENT,
            actionSubjectId: ACTION_SUBJECT_ID.STATUS,
            attributes: {
              inputMethod: INPUT_METHOD.QUICK_INSERT
            },
            eventType: EVENT_TYPE.TRACK
          })(tr);
          return tr;
        }
      }];
    }
  };
  return plugin;
};
export var statusPlugin = function statusPlugin(_ref4) {
  var options = _ref4.config,
    api = _ref4.api;
  return decorateWithPluginOptions(baseStatusPlugin({
    config: options,
    api: api
  }), options, api);
};